import { Heading1, Heading2, P, theme } from '@ovotech/element-v5';
import styled from 'styled-components';
import { SummaryCard } from '../../SummaryCard';

export const StyledCard = styled(SummaryCard)`
  height: 100%;
`;

export const StyledHeading = styled(Heading2)`
  color: ${theme.color.surface.onSurface};
`;

export const StyledHeadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[200]};
`;

export const StyledBalance = styled(Heading1)`
  color: ${theme.color.surface.onSurface};
`;

export const StyledDarkGreenLabel = styled(P)`
  color: ${theme.color.brand.dim};
`;

export const StyledInfoButton = styled.button`
  display: inline-flex;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
`;
